<template>
    <div>
      <AllCases :replaced_insurance="replaced"></AllCases>
    </div>
  </template>
    
    <script>
  import { defineAsyncComponent } from "vue";
  const AllCases = defineAsyncComponent(() =>
    import("@/components/cases/AllCases")
  );
  export default {
    components: {
      AllCases,
    },
    data() {
      return {
        replaced: true,
      };
    },
  };
  </script>
    